const decodeBase64url = (value) => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(base64 + '='.repeat((4 - base64.length % 4) % 4));
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return bytes.buffer;
};

const encodeBase64url = (buffer) => {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
};

export const registrationOptionsForBrowser = (options) => ({
  ...options,
  challenge: decodeBase64url(options.challenge),
  user: { ...options.user, id: decodeBase64url(options.user.id) },
  excludeCredentials: (options.excludeCredentials || []).map((credential) => ({
    ...credential,
    id: decodeBase64url(credential.id),
  })),
});

export const authenticationOptionsForBrowser = (options) => ({
  ...options,
  challenge: decodeBase64url(options.challenge),
  allowCredentials: (options.allowCredentials || []).map((credential) => ({
    ...credential,
    id: decodeBase64url(credential.id),
  })),
});

export const serializePasskeyCredential = (credential) => {
  const response = {
    clientDataJSON: encodeBase64url(credential.response.clientDataJSON),
  };

  if (credential.response.attestationObject) {
    response.attestationObject = encodeBase64url(credential.response.attestationObject);
    response.transports = credential.response.getTransports?.() || [];
  }
  if (credential.response.authenticatorData) {
    response.authenticatorData = encodeBase64url(credential.response.authenticatorData);
  }
  if (credential.response.signature) {
    response.signature = encodeBase64url(credential.response.signature);
  }
  if (credential.response.userHandle) {
    response.userHandle = encodeBase64url(credential.response.userHandle);
  }

  return {
    id: credential.id,
    rawId: encodeBase64url(credential.rawId),
    type: credential.type,
    response,
  };
};